<!-- begin::Footer -->
<footer class="m-grid__item		m-footer ">
    <div class="m-container m-container--fluid m-container--full-height m-page__container">
        <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
            <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
                <span class="m-footer__copyright">
                    2020 &copy; Startapps <a href="" class="m-link">Company</a>
                </span>
            </div>
            <!--<div class="m-stack__item m-stack__item&#45;&#45;right m-stack__item&#45;&#45;middle m-stack__item&#45;&#45;first">
                <ul class="m-footer__nav m-nav m-nav&#45;&#45;inline m&#45;&#45;pull-right">
                    <li class="m-nav__item">
                        <a href="#" class="m-nav__link">
                            <span class="m-nav__link-text">About</span>
                        </a>
                    </li>
                    <li class="m-nav__item">
                        <a href="#" class="m-nav__link">
                            <span class="m-nav__link-text">Privacy</span>
                        </a>
                    </li>
                    <li class="m-nav__item">
                        <a href="#" class="m-nav__link">
                            <span class="m-nav__link-text">T&C</span>
                        </a>
                    </li>
                    <li class="m-nav__item">
                        <a href="#" class="m-nav__link">
                            <span class="m-nav__link-text">Purchase</span>
                        </a>
                    </li>
                    <li class="m-nav__item m-nav__item">
                        <a href="#" class="m-nav__link" data-toggle="m-tooltip" title="Support Center"
                           data-placement="left">
                            <i class="m-nav__link-icon flaticon-info m&#45;&#45;icon-font-size-lg3"></i>
                        </a>
                    </li>
                </ul>
            </div>-->
        </div>
    </div>
</footer>
